export default __webpack_public_path__ + "static/media/BloDryBar.97b3d276.png";